import { render } from "./Index.vue?vue&type=template&id=2388a147&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2388a147"

export default script